import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'flowaccount-business-register-by-email',
  templateUrl: './business-register-by-email.component.html',
  styleUrls: ['./business-register-by-email.component.scss']
})
export class BusinessRegisterByEmailComponent implements OnInit {

  constructor(public translate: TranslateService) { }

  ngOnInit(): void {
  }

  loopArray(no: number) {
    return new Array(no)
  }

}
